import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
} from '@mui/material';

import type { ProjectBoardModal } from '../../commands/types';

export const ProjectBoardPickerDialog = ({
  open,
  modal,
  onClose,
}: {
  open: boolean;
  modal: ProjectBoardModal | null;
  onClose: () => void;
}) => {
  if (!modal) return null;

  const handleOpen = (projectId: string) => {
    window.open(`${modal?.baseUrl ?? ''}?projectId=${projectId}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{modal.title ?? 'Open project board'}</DialogTitle>
      <DialogContent>
        <Stack spacing={1} sx={{ mt: 1 }}>
          {modal.buttons.map((b) => (
            <Button key={b.id} variant="outlined" onClick={() => handleOpen(b.projectId)}>
              <Typography>{b.caption}</Typography>
            </Button>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectBoardPickerDialog;
